// Leaderboard display names derive PURELY from the submitted pseudo hash:
// the app, /board.html and the server never store a name — same hash, same
// name, nothing to moderate. 32×32×10000 ≈ 10M combos is plenty here.
const ANIMALS = [
  'Cá Chép', 'Hạc Giấy', 'Mèo Mun', 'Rồng Đất', 'Trâu Nước', 'Én Nhỏ',
  'Sóc Nâu', 'Cú Đêm', 'Thỏ Ngọc', 'Rùa Vàng', 'Hổ Giấy', 'Ngựa Gió',
  'Khỉ Đá', 'Gà Tre', 'Chó Đốm', 'Heo Đất', 'Chuột Nhắt', 'Dê Núi',
  // 'Vượn Núi' chứ đừng 'Vượn Trắng': emoji chỉ có khỉ nâu/đen/cam — tên
  // mang màu mà bộ emoji không có sẽ mâu thuẫn với avatar (pseudoAvatar).
  'Rắn Lục', 'Vượn Núi', 'Cáo Lửa', 'Nai Sao', 'Gấu Mật', 'Bướm Đêm',
  'Ong Thợ', 'Kiến Càng', 'Nhện Nước', 'Tôm Càng', 'Cua Đồng', 'Sếu Đỏ',
  'Vịt Trời', 'Sư Tử Đá',
];
const ADJS = [
  'Bay', 'Ẩn Cư', 'Tốc Hành', 'Trầm Mặc', 'Lãng Du', 'Khinh Công',
  'Vô Ảnh', 'Thần Hành', 'Phi Thiên', 'Độn Thổ', 'Nhàn Nhã', 'Cần Mẫn',
  'Tinh Anh', 'Hào Sảng', 'Bí Hiểm', 'Phiêu Dật', 'Kiên Định', 'Linh Hoạt',
  'Trác Việt', 'Uyên Thâm', 'Hoạt Bát', 'Điềm Tĩnh', 'Cơ Trí', 'Dũng Mãnh',
  'Khoan Thai', 'Mẫn Tiệp', 'Thanh Thoát', 'Cường Tráng', 'Nhẹ Nhõm',
  'Sắc Sảo', 'Bền Bỉ', 'Vui Tính',
];

// Linh vật cho avatar — CÙNG index với ANIMALS (sửa một bảng phải sửa bảng
// kia; test roundtrip giữ đồng bộ độ dài). Ưu tiên bản "mặt" khi có vì
// avatar chỉ ~24px.
const EMOJIS = [
  '🐟', '🕊️', '🐈‍⬛', '🐉', '🐃', '🐦',
  '🐿️', '🦉', '🐇', '🐢', '🐯', '🐴',
  '🐵', '🐓', '🐶', '🐷', '🐭', '🐐',
  '🐍', '🐒', '🦊', '🦌', '🐻', '🦋',
  '🐝', '🐜', '🕷️', '🦐', '🦀', '🦩',
  '🦆', '🦁',
];
const TONES = 10; // .ava.t0–.t9 trong board.css — palette mực, tĩnh vì CSP

export function pseudoName(hex) {
  if (typeof hex !== 'string' || !/^[0-9a-f]{16,}$/i.test(hex)) return 'Ẩn Danh';
  const a = parseInt(hex.slice(0, 4), 16);
  const b = parseInt(hex.slice(4, 8), 16);
  const d = parseInt(hex.slice(8, 12), 16) % 10000;
  return `${ANIMALS[a % ANIMALS.length]} ${ADJS[b % ADJS.length]} #${String(d).padStart(4, '0')}`;
}

// Danh tính gửi lên server = SHA-256(id cục bộ) cắt 16 byte — id thô không
// bao giờ rời máy. bench_client dùng khi tạo/gửi; /board đọc lại CÙNG phép
// băm để nhận ra "hàng của tôi". Hai nơi phải chung một thuật toán, vì vậy
// nó sống ở đây chứ không nhân đôi.
export const PSEUDO_STORAGE_KEY = 'moxhi.pseudo';
export async function derivePseudo(id) {
  const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(id));
  return [...new Uint8Array(digest).slice(0, 16)]
    .map((b) => b.toString(16).padStart(2, '0')).join('');
}

// Avatar đi theo tên: emoji = đúng con vật đứng đầu pseudoName (cùng slice),
// tone màu lấy từ nhóm hex khác để hai người chung con vật vẫn thường khác
// màu. Hash hỏng → dấu chân mực xám, khớp tên 'Ẩn Danh'.
export function pseudoAvatar(hex) {
  if (typeof hex !== 'string' || !/^[0-9a-f]{16,}$/i.test(hex)) {
    return { emoji: '🐾', tone: 8 };
  }
  const a = parseInt(hex.slice(0, 4), 16);
  const c = parseInt(hex.slice(12, 16), 16);
  return { emoji: EMOJIS[a % EMOJIS.length], tone: c % TONES };
}
